import { Modal } from '@get-mosh/msh-shared';

const DefaultNotificationModal = ({
    isOpen,
    onRequestClose,
}: {
    isOpen: boolean;
    onRequestClose: () => void;
}) => {
    return (
        <Modal
            className="!border-0 !p-0"
            isOpen={isOpen}
            onModalClose={() => {
                onRequestClose();
            }}
        >
            <div className="px-4 py-8 sm:w-[375px] md:h-auto md:w-[458px]">
                <h3 className="text-left">Default notifications</h3>
                <span className="text-left text-base font-normal text-grey-400">
                    We subscribe you to the following email notifications and
                    announcements when you create an account. Adjust your
                    preferences from your account settings or unsubscribe at any
                    time.
                </span>
                <div className="flex flex-row items-center gap-4 pt-6">
                    <span className="pb-2 font-demi text-xs text-grey-400">
                        Adjustable
                    </span>
                    <div className="flex-1 border-t border-grey-200"></div>
                </div>
                <div className="g-3 inline-flex items-start justify-start">
                    <span className="text-left font-demi">
                        <ul className="list-disc pl-5">
                            <li>Your health journey</li>
                            <li>Marketing offers and updates</li>
                            <li>Product updates</li>
                            <li>Newsletter</li>
                            <li>Surveys & feedback</li>
                        </ul>
                    </span>
                </div>
            </div>
        </Modal>
    );
};

export default DefaultNotificationModal;
